import React, { useContext } from 'react';

import PropTypes from 'prop-types';

import Form from '@asteria/component-form';

import LoadingScreen from '@asteria/layout/loading';
import { cn } from '@asteria/utils-funcs/classes';

import FormUpdater from '../../components/form-updater';
import Header from '../../components/header';
import { ForecasterContext } from '../../context';
import { useForecastQuery } from '../../hooks';

import SectionActions from './actions';
import SectionGraph from './graph';
import SectionTeaser from './teaser';

import './styles.scss';

const HomePage = React.memo(({ className, selectedScenario }) => {
	const { onAction, onSubmit } = useContext(ForecasterContext);
	const data = useForecastQuery({ selectedScenario });

	return (
		<div
			className={cn(
				'asteria-component__forecaster-page',
				'asteria--type-home',
				className,
			)}
		>
			<Header />

			<div className="relative">
				{data.loading ? (
					<LoadingScreen
						className="-left-8 -right-8"
						blur
						type="forecaster"
					/>
				) : null}
				<Form>
					<FormUpdater
						history={data.history}
						yearHistory={data.yearHistory}
						forecast={data.forecast}
						scenario={data.scenario}
					/>
					<SectionGraph />
					<SectionActions onAction={onAction} onSubmit={onSubmit} />
				</Form>
				<SectionTeaser onAction={onAction} onSubmit={onSubmit} />
			</div>
		</div>
	);
});

HomePage.displayName = 'HomePage';

HomePage.propTypes = {
	className: PropTypes.string,
	onAction: PropTypes.func,
	onSubmit: PropTypes.func,
};

export default HomePage;
